import React from "react";
import PngResizerUseCase from "./PngResizerUseCase";
import PngResizerFaq from "./PngResizerFaq";
import {PngResizeByDimensions} from "./PngResizeByDimensions";

const PngResizerPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <PngResizeByDimensions />
                <PngResizerUseCase />
                <PngResizerFaq />
            </div>
        </div>
    );
};

export default PngResizerPreToolsArea;
